<template>
  <div class="err">
    <img class="banner" src="../assets/img/404.png" alt="">
    <div class="err_msg">对不起，您访问的页面不存在</div>
    <div class="btn_box">
      <table width="100%">
        <tr>
          <td width="50%"><span @click="$router.push('/')">返回首页</span></td>
          <td width="50%"><span @click="$router.go(-1)">返回上一页</span></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .err {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
    padding-top: 90px;
    padding-left: 36px;
    padding-right: 36px;
  }
  .banner{
    width: 100%;
    height: 100%;
  }
  .err_msg{
    height:25px;
    font-size:18px;
    color: #333333;
    line-height:25px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .btn_box{
    height:22px;
    font-size:16px;
    color:rgba(236,100,112,1);
    line-height:22px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/404.vue